import { Component, OnInit, ViewChild } from '@angular/core';
import { Alert, AlertService, PaginatorFetcher, PaginatorFilters, TableComponent, TableConfig } from '@michelin/theme';
import { Router } from '@angular/router';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { PAGINATION_SIZES } from 'src/app/shared/utils/constants';
import { AutomakerDto } from 'src/app/shared/models/automaker/automaker-dto';
import { DistributorStockDto } from 'src/app/shared/models/distributor/distributor-stock-dto';
import { DistributorStockService } from 'src/app/shared/services/distributor-stock/distributor-stock.service';
import { DistributorDto } from 'src/app/shared/models/distributor/distributor-dto';
import { DistributorService } from 'src/app/shared/services/distributor/distributor.service';

@Component({
    selector: 'app-list-distributor-stock',
    templateUrl: './list-distributor-stock.component.html',
    standalone: false
})
export class ListDistributorStockComponent implements OnInit {
  loading = false;

  distributors: DistributorDto[] = [];

  tableConfig: TableConfig<DistributorStockDto> = {
    paginator: {
      pageSize: 10,
      position: 'bottom',
      pageSizeOptions: PAGINATION_SIZES
    },
    columns: {
      companyName: { header: 'Distribuidor', sortable: true, cell: (item) => item.companyName },
      tradeName: { header: 'Nome Fantasia', sortable: true, cell: (item) => item.tradeName },
      document: { header: 'CNPJ', sortable: true, cell: (item) => item.document },
      productName: { header: 'Descrição', sortable: true, cell: (item) => item.productName },
      productCode: { header: 'CAI', sortable: true, cell: (item) => item.productCode.replace('.0', '') },
      quantity: { header: 'Estoque', sortable: true, cell: (item) => Number(item.quantity.replace(',', '.')).toFixed(0).toString() },
      date: { header: 'Data', sortable: true, cell: (item) => item.date }
    }
  };

  filterForm: FormGroup = this.formBuilder.group({
    distributor: this.formBuilder.control('', { nonNullable: true }),
    document: this.formBuilder.control('', { nonNullable: true }),
    productName: this.formBuilder.control('', { nonNullable: true }),
    productCode: this.formBuilder.control('', { nonNullable: true })
  });

  fetcher: PaginatorFetcher<DistributorStockDto> = (filters: PaginatorFilters) => this.distributorStockService.search(filters);

  @ViewChild(TableComponent, { static: true }) table: TableComponent<AutomakerDto>;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly router: Router,
    private readonly distributorStockService: DistributorStockService,
    private readonly distributorService: DistributorService,
    private readonly alertService: AlertService
  ) {}

  get filterValues(): any {
    return {
      document: this.filterForm.get('document').value,
      productName: this.filterForm.get('productName').value,
      productCode: this.filterForm.get('productCode').value,
      distributorId: this.filterForm.get('distributor').value?.id || null
    };
  }

  get distributor(): FormControl {
    return this.filterForm.get('distributor') as FormControl;
  }

  get document(): FormControl {
    return this.filterForm.get('document') as FormControl;
  }

  applyFilter() {
    this.table.patchExtraFilters(this.filterValues, true);
  }

  resetFilter() {
    this.filterForm.reset();
    this.table.patchExtraFilters(this.filterValues, true);
  }

  redirectToEdit(item: AutomakerDto) {
    this.router.navigate([`/automakers/${item.id}/update`]);
  }

  companyDisplayName(item: DistributorDto): string {
    return item?.company?.tradeName;
  }

  ngOnInit() {
    this.loading = true;
    this.distributorService
      .findAll()
      .subscribe({
        next: (result) => (this.distributors = result),
        error: () =>
          this.alertService.showAlert({
            type: 'critical',
            content: 'Ocorreu um erro ao recuperar as informações dos distribuidores.'
          } as Alert)
      })
      .add(() => (this.loading = false));
    this.distributor.valueChanges.subscribe((value) => {
      if (value) {
        this.document.disable();
        this.document.setValue(value.company.document);
        console.log(value);
      } else {
        this.document.enable();
        this.document.setValue('');
      }
    });
  }
}
